import { type Theme } from '../../../../../theme';
import { type ButtonStyles } from '../button.types';

export const getDestructiveButton = (theme: Theme): ButtonStyles => ({
  base: {
    color: theme.button.destructive.label,
    backgroundColor: theme.button.destructive.default,
    boxShadow:
      '0 1px 0 0 rgba(0, 0, 0, 0.06), 0 1px 2px 0 rgba(0, 0, 0, 0.05), 0 4px 6px 0 rgba(255, 255, 255, 0.15) inset',
    border: `1px solid ${theme.button.destructive.border}`,
    '&:hover': {
      background: theme.button.destructive.hover,
      backgroundBlendMode: 'normal',
    },
    '&:active, &:focus:not(:focus-visible)': {
      background: `linear-gradient(180deg, rgba(255, 255, 255, 0.25) 0%, rgba(255, 255, 255, 0) 100%), ${theme.button.destructive.pressed}`,
      backgroundBlendMode: 'lighten, normal',
      outline: 'none',
    },
    '&:focus': {
      outline: `2.5px solid ${theme.button.focused.desctructive}`,
      outlineOffset: 4,
      backgroundColor: theme.button.destructive.default,
    },
  },
  active: {},
  isLoading: {
    background: theme.button.destructive.default,
  },
  disabled: {
    backgroundColor: theme.button.destructive.disabled,
    border: `1px solid ${theme.button.destructive.border}`,
    color: theme.button.disabled.label,
    cursor: 'not-allowed',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: 'none',
    },
    '&:active, &:focus:not(:focus-visible)': {
      outline: 'none',
      boxShadow: 'none',
    },
    svg: {
      color: theme.text.interactive.disabled,
    },
  },
});
